import React from 'react';
import useSocialAuth from 'hooks/useSocialAuth';
import { preventDefaultWrapper } from 'utils';
import useWindowSize from 'hooks/useWindowSize';
import { useTrans } from 'ui';
import Google from './google.svg';
import { Flex, Layout } from '../../layout';
import Vk from './vk.svg';
import Ya from './ya.svg';
import { BaseSmmLoginButton } from './BaseSmmLoginButton';
import smmStrings from './Smm.strings';

export function SmmButtons(props: { isLogin: boolean } = { isLogin: true }) {
  const {
    openGoogle, openVk, openYandex,
  } = useSocialAuth({ isLogin: props.isLogin });
  const { t } = useTrans();
  const [width] = useWindowSize();

  const googleText = t(smmStrings.google);
  const vkText = t(smmStrings.vk);
  const yaText = t(smmStrings.yandex);

  return (
    <Layout direction="row">
      <BaseSmmLoginButton
        hover="#2a75f3"
        background="#4285F4"
        text={googleText}
        icon={<Google />}
        small={width < 800}
        onClick={preventDefaultWrapper(openGoogle)}
      />
      <Flex basis={15} />
      <BaseSmmLoginButton
        hover="#3371B8"
        background="#4680C2"
        text={vkText}
        icon={<Vk />}
        small={width < 800}
        onClick={preventDefaultWrapper(openVk)}
      />
      <Flex basis={15} />
      <BaseSmmLoginButton
        hover="#E52B2B"
        background="#FF4D4D"
        text={yaText}
        onClick={preventDefaultWrapper(openYandex)}
        icon={(
          <Flex basis={30}>
            <Ya />
          </Flex>
        )}
        small
        grow={false}
      />
    </Layout>
  );
}
